import type { Metadata } from 'next';
import { UI_TEXT_CONSTANTS } from '@/lib/constants/appConstants';
import { getBrandDisplayName, getBrandFromDomain } from '@/lib/utils/brandUtils';

const BRAND_FAVICON_MAP: Record<string, string> = {
  tracfone: '/content/dam/tracfone/icons/favicon.ico',
  totalwireless: '/content/dam/tbvz/en/hero-carousel/favicon/favicon_tbv.png',
  straighttalk: '/content/dam/straighttalk/icons/favicon.ico',
  simplemobile: '/favicon.ico',
  net10: '/favicon.ico',
  safelink: '/en/favicon.ico',
  familymobile: '/favicon.ico',
  gosmartmobile:
    '/wps/contenthandler/!ut/p/digest!2qJV6EHumctbx7A9NQj-wg/dav/fs-type1/themes/GoSmart_RWD_Theme_WebDAV/images/favicon.ico',
};

export const getMetadataFromOrigin = (origin: string): Metadata => {
  const brand = getBrandFromDomain(origin || '');
  const brandDisplayName = getBrandDisplayName(brand);
  const brandIcon = BRAND_FAVICON_MAP[brand?.toLowerCase() || ''] || '/file.svg';

  return {
    title: UI_TEXT_CONSTANTS.DEFAULTS.PAGE_TITLE.replace('brand_name', brandDisplayName),
    description: UI_TEXT_CONSTANTS.DEFAULTS.PAGE_DESCRIPTION.replace('brand_name', brandDisplayName),
    icons: {
      icon: [
        { url: brandIcon, type: 'image/png' },
        { url: '/file.svg', type: 'image/svg+xml' },
      ],
      shortcut: [
        { url: brandIcon, type: 'image/png' },
        { url: '/file.svg', type: 'image/svg+xml' },
      ],
      apple: [{ url: brandIcon, type: 'image/png' }],
    },
  };
};
